// React
import React, { Suspense } from "react";
// Router
import { HashRouter, Route, Routes } from "react-router-dom";
// Components
import FullscreenLoader from "./components/FullscreenLoader";
import { TooltipProvider } from "./components/ui/tooltip";
// Styles
import "./App.scss";
import "react-toastify/dist/ReactToastify.css";

// Containers
const DefaultLayout = React.lazy(
    () =>
        import(
            "./containers/DefaultLayout" /* webpackChunkName: "DefaultLayout" */
        )
);
// Pages
const Login = React.lazy(
    () => import("./views/Login" /* webpackChunkName: "Login" */)
);
const Passwords = React.lazy(
    () => import("./views/Passwords" /* webpackChunkName: "Passwords" */)
);
const TwoFactorLogin = React.lazy(
    () =>
        import(
            "./views/TwoFactorLogin" /* webpackChunkName: "TwoFactorLogin" */
        )
);
const ResetPassword = React.lazy(
    () =>
        import("./views/ResetPassword" /* webpackChunkName: "ResetPassword" */)
);

import { ToastContainer } from "react-toastify";

// Función para obtener el entorno sin depender de utils.js
const getLocalEnvironment = () => {
    const { hostname } = window.location;
    const environment = hostname.split(".").shift();
    if (environment.includes("qa")) return "qa";
    if (environment.includes("staging")) return "staging";
    if (environment.includes("localhost")) return "local";
    return "prod";
};

const environment = getLocalEnvironment();
const styleByEnvironment = {
    staging: { backgroundColor: "#4a85e8" },
    qa: { backgroundColor: "#ff9800" },
    local: { backgroundColor: "#2eb85c" },
    prod: { display: "none" },
};

const App = () => (
    <HashRouter>
        <TooltipProvider>
            <ToastContainer position="top-right" />
            <section
                className="warning-environment"
                style={{ ...styleByEnvironment[environment] }}
            >
                {environment}
            </section>
            <Suspense fallback={<FullscreenLoader />}>
                <Routes>
                    <Route
                        path="/digiventures-spinner"
                        element={<FullscreenLoader />}
                    />
                    <Route path="/login" element={<Login />} />
                    <Route
                        path="/obligate_change_password"
                        element={<Passwords />}
                    />
                    <Route path="/login_2fa" element={<TwoFactorLogin />} />
                    <Route path="/reset_password" element={<ResetPassword />} />
                    <Route path="/*" element={<DefaultLayout />} />
                </Routes>
            </Suspense>
        </TooltipProvider>
    </HashRouter>
);

export default App;
